/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_range.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Constructs a range from two boundary values. The first argument is the inclusive lower bound; the second is the exclusive upper bound, following the half-open `[from, to)` convention used for all range types in ES|QL. Accepts `datetime` arguments and returns a `date_range`, or accepts `double` arguments and returns a `double_range`.',
  examples: [
    'ROW from_dt = TO_DATETIME("2000-01-01T00:00:00.000Z"), to_dt = TO_DATETIME("2010-01-01T00:00:00.000Z")\n| EVAL r = TO_RANGE(from_dt, to_dt)\n| KEEP r',
  ],
  params: {
    from: 'Inclusive lower bound of the range (`[from, to)`). If `null`, the function returns `null`.',
    to: 'Exclusive upper bound of the range (`[from, to)`). If `null`, the function returns `null`.',
  },
};

export default docs;
